// extracted by mini-css-extract-plugin
module.exports = {"container":"LineThrough__container___2PmOW","divider":"LineThrough__divider___1z8cS","text":"LineThrough__text___ox9m2"};